import { render, staticRenderFns } from "./AgreementCarrierMessageAlert.vue?vue&type=template&id=18dc5858&scoped=true"
import script from "./AgreementCarrierMessageAlert.vue?vue&type=script&lang=js"
export * from "./AgreementCarrierMessageAlert.vue?vue&type=script&lang=js"
import style0 from "./AgreementCarrierMessageAlert.vue?vue&type=style&index=0&id=18dc5858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc5858",
  null
  
)

export default component.exports